import styled from "@emotion/styled";

const OnboardingFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export default OnboardingFormContainer;
